import { render, staticRenderFns } from "./PortalSummary.vue?vue&type=template&id=e16c174e"
import script from "./PortalSummary.vue?vue&type=script&lang=js"
export * from "./PortalSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports